module.exports = __webpack_public_path__ + "static/img/r2.d509577.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/r2.png
// module id = KJPz
// module chunks = 0